<script>
import StatusCard from './StatusCard.vue';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment/moment';

export default {
    name: 'HipaaFormValidation',

    components: { StatusCard },

    props: {
        playerID: {
            type: String,
            required: true,
        },
        playerEmail: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            hipaaAnnualFormValidation: {},
            hipaaAnnualFormSharepointUrl: null,
        };
    },
    emits: ['is-hipaa-form-valid'],
    mounted() {
        this.getPlayerHipaaConsentForm({
            playerIdentifier: this.playerID,
            playerEmail: this.playerEmail,
        })
            .then((response) => {
                this.$store.dispatch('information/retrieveFormsStartDates').then(([annualOldDate, annualNewDate, healthOldDate, healthNewDate]) => {
                    if (moment().format('YYYY-MM-DD') >= moment(healthNewDate).format('YYYY-MM-DD')) {
                        this.hipaaAnnualFormSharepointUrl = process.env.VUE_APP_PLAYER_HIPAA_FORMS_CURRENT_YEAR;
                    } else if (
                        moment().format('YYYY-MM-DD') >= moment(healthOldDate).format('YYYY-MM-DD') &&
                        moment().format('YYYY-MM-DD') < moment(healthNewDate).format('YYYY-MM-DD')
                    ) {
                        this.hipaaAnnualFormSharepointUrl = process.env.VUE_APP_PLAYER_HIPAA_FORMS_PREVIOUS_YEAR;
                    }

                    this.hipaaAnnualFormValidation = response;
                });
            })
            .catch((error) => {
                console.error(error);
                this.$message({
                    showClose: true,
                    message:
                        'Could not retrieve information from WTA backend systems. ' +
                        'Retrying in 5 seconds. If the problem persists then contact the Administrator',
                    type: 'error',
                    duration: 0,
                });
            });
    },
    computed: {
        ...mapGetters('playerConsentFormStore', ['hasTheHipaaConsentFormBeenSigned', 'loadingPlayerHipaaConsentFormError']),
        ...mapGetters('information', ['healthOldDate', 'healthNewDate']),
    },
    watch: {
        isHipaaFormValid: {
            handler() {
                this.$emit('is-hipaa-form-valid', this.hasTheHipaaConsentFormBeenSigned);
            },
            deep: true,
        },
    },
    methods: {
        ...mapActions('playerConsentFormStore', ['getPlayerHipaaConsentForm']),
    },
};
</script>

<template>
    <StatusCard
        :message="loadingPlayerHipaaConsentFormError || 'Health Authorization Form'"
        :success="(!!hasTheHipaaConsentFormBeenSigned && !loadingPlayerHipaaConsentFormError) || false"
        :linkText="loadingPlayerHipaaConsentFormError ? '' : 'Sign Form'"
        :linkUrl="loadingPlayerHipaaConsentFormError ? '' : hipaaAnnualFormSharepointUrl"
    />
</template>

<style scoped lang="scss"></style>
